import Vue from 'vue';
import { Message } from 'element-ui';

export default {
    getFormData({commit, state}, id = '') {
        commit('updateLoadingState', {
            loading: 'isLoading',
            state: true
        });

        $.ajax({
            url: '/social-covers/share-json/' + id,
            method: 'GET',
            data: {
                editable: state.formEditableParam,
                category: state.formMediaCategoryParam
            },
            global: false
        })
        .done((data) => {
            commit('updateLoadingState', {
                loading: 'isLoading',
                state: false
            });

            commit('getFormData', data);
            commit('oembed/updateUrl', data.post_image_url, {root: true});
        })
        .fail((xhr) => {
            commit('updateLoadingState', {
                loading: 'isLoading',
                state: false
            });
            console.error('something went wrong', xhr);
        });
    },

    getPost({commit, state}, id) {
        commit('updateLoadingState', {
            loading: 'isLoading',
            state: true
        });

        $.ajax({
            url: `/social-covers/get/${id}`,
            method: 'GET',
            global: false
        })
        .done((data) => {
            commit('updateLoadingState', {
                loading: 'isLoading',
                state: false
            });

            commit('getPost', data);
        })
        .fail((xhr) => {
            commit('updateLoadingState', {
                loading: 'isLoading',
                state: false
            });
            console.error('something went wrong', xhr);
        });
    },

    getPosts({commit, state}) {
        commit('updateLoadingState', {
            loading: 'isLoading',
            state: true
        });

        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/social-covers/scheduled-json',
                method: 'GET',
                data: state.params,
                global: false
            })
            .done((data) => {
                commit('updateParams', {
                    page: parseInt(data.meta.current_page) + 1
                });
                commit('updateLoadingState', {
                    loading: 'isLoading',
                    state: false
                });
                resolve(data);
            })
            .fail((xhr) => {
                commit('updateLoadingState', {
                    loading: 'isLoading',
                    state: false
                });
                reject(xhr);
                console.error('something went wrong', xhr);
            });
        });
    },

    postForm({commit, state, getters}) {
        commit('updateLoadingState', {
            loading: 'isPosting',
            state: true
        });

        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/social-covers/social-form',
                data: getters.postFormattedFormData,
                method: 'POST',
                global: false
            })
            .done((data) => {
                commit('updateLoadingState', {
                    loading: 'isPosting',
                    state: false
                });
                resolve(data);
            })
            .fail((xhr) => {
                reject(xhr);
                commit('updateLoadingState', {
                    loading: 'isPosting',
                    state: false
                });
                console.error('something went wrong', xhr);
            });
        });
    },

    updatePost({commit, state, getters}) {
        commit('updateLoadingState', {
            loading: 'isPosting',
            state: true
        });

        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/social-covers/update',
                data: getters.postFormattedFormData,
                method: 'POST',
                global: false
            })
            .done((data) => {
                commit('updateLoadingState', {
                    loading: 'isPosting',
                    state: false
                });
                resolve(data);
            })
            .fail((xhr) => {
                reject(xhr);
                commit('updateLoadingState', {
                    loading: 'isPosting',
                    state: false
                });
                console.error('something went wrong', xhr);
            });
        });
    },

    deletePost({commit, state}, id) {
        $.ajax({
            url: `/social-covers/remove/${id}`,
            method: 'POST',
            global: false
        })
        .done((data) => {
            commit('removePost', id);
            Message({
                type: 'success',
                message: 'Post Deleted'
            })
        })
        .fail((xhr) => {
            console.error('something went wrong', xhr);
        });
    },
}